module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.restore-mobile-access')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.entity,
      "fields": _vm.fields
    },
    on: {
      "submit": _vm.submit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c894b94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/RestoreMobileAccess.vue
// module id = 967
// module chunks = 2